import React from 'react';
import LegalLayout, { Section } from '../components/LegalLayout';

const CancellationRefunds = () => (
  <LegalLayout title="Cancellation & Refund Policy" effectiveDate="August 28, 2026">
    <Section title="">
      <p>YOVAI Provides Customized AI Implementation And Recurring Automation Services.</p>
    </Section>

    <Section title="Subscription Cancellation">
      <p>Clients May Request Cancellation Using YOVAI's Published Contact Information.</p>
      <p>Unless Otherwise Stated In A Separate Written Agreement, Cancellation Prevents Future Subscription Renewals.</p>
      <p>Clients Should Submit Cancellation Requests Before Their Next Billing Date To Avoid A Subsequent Scheduled Renewal.</p>
    </Section>

    <Section title="Professional Implementation Fees">
      <p>Professional Implementation Fees Cover Customized Configuration And Implementation Work.</p>
      <p>Implementation Fees Are Generally Non-Refundable Once Implementation Work Has Begun, Except Where Required By Applicable Law Or Otherwise Agreed To By YOVAI In Writing.</p>
    </Section>

    <Section title="Recurring Payments">
      <p>Subscription Charges For Service Periods That Have Already Begun Are Generally Non-Refundable Except Where Required By Applicable Law Or Expressly Approved By YOVAI.</p>
      <p>Cancellation Does Not Automatically Create A Refund For Previously Incurred Charges.</p>
      <p>Nothing In This Policy Limits Rights That Cannot Lawfully Be Waived.</p>
    </Section>
  </LegalLayout>
);

export default CancellationRefunds;
